import { Typography } from 'antd';
import { noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import PFileListModal from 'pages/Payment/PFileListModal';

export type PFileSelectInputType = {
  pfid?: string;
};

export type PFileSelectInputProps = {
  onChange?: any;
  value?: PFileSelectInputType;
  paydirection?: string;
};

const PFileSelectInput = ({
  onChange = noop,
  value,
  paydirection,
}: PFileSelectInputProps) => {
  const [Params, setParams] = useState<PFileSelectInputType>({
    pfid: value?.pfid,
  });

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onChange(item);
    setParams({ pfid: item });

    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={open}
        value={
          <Typography.Link>
            {!value?.pfid
              ? Params?.pfid
                ? `Payment file ID : ${Params.pfid ?? ''} `
                : 'Select Payment File'
              : value?.pfid
              ? `Payment file ID : ${Params.pfid ?? ''} `
              : 'Select Payment File'}
          </Typography.Link>
        }
      />
      <PFileListModal
        visible={visible}
        onCancel={close}
        paydirection={paydirection ?? 'IN'}
        onChange={handleSelect}
      />
    </>
  );
};

export default PFileSelectInput;
